(ns frontend.view.grid.investors-grid.columns)

;;default set of selected columns
(def ordered-default-columns
  [:investor/name
   :investor/cur-typical-investment-min
   :investor/description
   :investor/investor-type
   :investor/focus-stage
   :investor/focus-sector
   :investor/focus-geography])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:investor/name})
